import { FullSizeContainer } from 'components/FullSizeContainer';
import { LoginPage } from 'pages/auth/Login';
import { ResetPasswordPage } from 'pages/auth/ResetPassword';
import { Route, Routes } from 'react-router-dom';
import { authRoutes } from 'routes';

export const Auth = () => {
  return (
    <FullSizeContainer>
      <Routes>
        <Route path={authRoutes.login} element={<LoginPage />} />
        <Route
          path={authRoutes.resetPassword}
          element={<ResetPasswordPage />}
        />
      </Routes>
    </FullSizeContainer>
  );
};
